/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title:
    "Daniel Constante - Principal Full Stack Software Engineer | Dallas Portfolio",
  description:
    "Daniel Constante: Full Stack Software Engineer in Dallas/DFW, specializing in React, UI/UX, and scalable web applications. Explore my projects, resume, and contact info.",
  keywords:
    "Daniel Constante, Daniel Constante Portfolio, Full Stack Developer Dallas, React Developer DFW, Software Engineer Texas, Web Development Portfolio",
  og: {
    title:
      "Daniel Constante - Principal Full Stack Software Engineer Portfolio",
    type: "website",
    url: "https://danielconstante.netlify.app/",
    description:
      "A passionate Full Stack Software Engineer in Dallas/DFW, specializing in React, UI/UX, and end-to-end web applications. Explore my work and connect.",
    image: "https://danielconstante.netlify.app/icons/dclogo.png",
    site_name: "Daniel Constante Portfolio",
  },
  twitter: {
    card: "summary_large_image",
    title: "Daniel Constante - Principal Full Stack Software Engineer",
    description:
      "Dallas-based developer passionate about React, front-end, and scalable web apps.",
    image: "https://danielconstante.netlify.app/icons/dclogo.png",
    creator: "@dconstante_86",
  },
};

//Home Page
const greeting = {
  title: "Daniel Constante",
  logo_name: "DanielConstante",
  nickname: "",
  subTitle:
    "Full Stack Software Engineer specializing in front-end development, based in the Dallas/DFW area. I am passionate about crafting web applications and user interfaces that combine polished design, engaging animations, and seamless, dynamic user experiences.",
  resumeLink:
    "https://drive.google.com/file/d/1DkFcmBZJQTqETmwgz6OLigzQQ1sJwVqV/view?usp=drivesdk",
  portfolio_repository: "https://github.com/DanielConstante/dcportfolio",
  githubProfile: "https://github.com/DanielConstante",
  services: "https://dcnetwork.netlify.app/",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  {
    name: "Github",
    link: "https://github.com/DanielConstante",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#2C55E5", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "www.linkedin.com/in/daniel-constante86/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#2C55E5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "X-Twitter",
    link: "https://x.com/dconstante_86/",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#2C55E5", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/danielconstante86/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#2C55E5", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/danielconstante86/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#2C55E5", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Outlook",
    link: "mailto:daniel_constante86@outlook.com",
    fontAwesomeIcon: "fa-brands fa-microsoft", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#2C55E5", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:daniel.constante2086@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#2C55E5", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Designing and developing responsive, high-performance front-end web applications using React, Redux, JavaScript, and TypeScript, with a focus on clean architecture, reusable components, and state management.",
        "⚡ Implementing best practices for accessibility (WCAG standards), cross-browser compatibility, and seamless user experiences through intuitive UI design and robust client-side logic.",
        "⚡ Developing high-quality, cross-platform mobile applications using React Native, leveraging its robust ecosystem for seamless performance and native-like user experiences.",
        "⚡ Designing and developing scalable, high-performance backend systems using Ruby on Rails, ensuring robust APIs and seamless database integrations.  ",
        "⚡ Experienced in building enterprise-grade solutions using Java, with a focus on multi-threading, microservices, and efficient backend processing.",
        "⚡ Proficient in three tech stacks:",
      ],
      stacks: [
        {
          name: "MERN",
          description:
            "MongoDB, Express.js, React, Node.js for dynamic and responsive full-stack applications.",
          logos: [
            { name: "MongoDB", className: "skill-icons:mongodb" },
            { name: "Express.js", className: "skill-icons:expressjs-dark" },
            { name: "React", className: "devicon:react" },
            { name: "Node.js", className: "logos:nodejs" },
          ],
        },
        {
          name: "RAJA",
          description:
            "React, Java, SQL, and AWS for building scalable, cloud-based enterprise solutions.",
          logos: [
            { name: "React", className: "devicon:react" },
            { name: "Java", className: "skill-icons:java-dark" },
            { name: "SQL", className: "logos:mysql" },
            { name: "AWS", className: "simple-icons:amazonaws" },
          ],
        },
        {
          name: "R2PH",
          description:
            "React, Ruby on Rails, PostgreSQL, and Heroku for developing robust, cloud-hosted applications.",
          logos: [
            { name: "React", className: "devicon:react" },
            { name: "Ruby on Rails", className: "devicon:ruby" },
            { name: "PostgreSQL", className: "logos:postgresql" },
            { name: "Heroku", className: "skill-icons:heroku" },
          ],
        },
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "devicon:typescript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "skill-icons:git",
          style: {
            color: "#2C8EBB",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Firewall",
          fontAwesomeClassname: "iconoir:pc-firewall",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Ruby on Rails",
          fontAwesomeClassname: "simple-icons:rubyonrails",
          style: {
            color: "#CC0000",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
        "⚡ Using platforms like Wix, Squarespace, and WordPress to design and develop fully customized websites tailored to client needs.",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Canva",
          fontAwesomeClassname: "devicon:canva",
          style: {
            // color: "#000000",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "logos:figma",
          style: {
            // color: "#F24E1E",
          },
        },
        {
          skillName: "SquareSpace",
          fontAwesomeClassname: "fa-brands:squarespace",
          style: {
            //color: "#FF7C00",
          },
        },
        {
          skillName: "WIX",
          fontAwesomeClassname: "simple-icons:wix",
          style: {
            // color: "#000000",
          },
        },
        {
          skillName: "WordPress",
          fontAwesomeClassname: "ic:baseline-wordpress",
          style: {
            // color: "#000000",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Codepen",
      iconifyClassname: "mdi:codepen",
      style: {
        color: "#000000",
      },
      profileLink: "https://codepen.io/dante86c",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/daniel_constant5",
    },
    {
      siteName: "Codesandbox",
      iconifyClassname: "logos:codesandbox-icon",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://codesandbox.io/u/danielconstante",
    },
    {
      siteName: "Codecademy",
      iconifyClassname: "simple-icons:codecademy",
      style: {
        color: "#000",
      },
      profileLink: "https://www.codecademy.com/profiles/danielconstante86",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Central University of Ecuador",
      subtitle: "Business Administration",
      logo_path: "ucentral.png",
      alt_name: "Central University of Ecuador logo",
      duration: "2006 - 2008",
      descriptions: [
        "⚡ Acquired a strong foundation in business management, including finance, marketing, and human resources, through a comprehensive two-year curriculum.",
        "⚡ Developed strong analytical and problem-solving skills by applying business theories to real-world case studies and practical projects.",
        "⚡ Contributed to multiple group projects, enhancing teamwork and communication skills while developing business plans and market analyses.",
        "⚡ Gained proficiency in essential business software, including spreadsheet applications for financial analysis and presentation tools for effective communication.",
      ],
      website_link: "https://www.nucamp.co/",
    },
    {
      title: "Nucamp Coding Bootcamp",
      subtitle: "Full Stack Web and Mobile App Developer",
      logo_path: "nclogo.PNG",
      alt_name: "nucamp logo",
      duration: "2019 - 2021",
      descriptions: [
        "⚡ Achieved the Full Stack Web and Mobile App Developer Certificate with Honors, demonstrating advanced proficiency in modern frameworks like React, React Native, and Node.js.",
        "⚡Successfully built responsive, scalable web and mobile applications with a focus on clean architecture, efficient state management, and dynamic user interfaces.",
        "⚡ Honored for excellence in mastering full-stack technologies, including Express.js, MongoDB, and RESTful APIs.",
        "⚡ Earned the certificate with honors for exceptional performance in designing end-to-end web and mobile applications.",
      ],
      website_link: "https://www.nucamp.co/",
    },
    {
      title: "Western Governors University",
      subtitle: "B.S. in Software Engineering",
      logo_path: "WGULogo.png",
      alt_name: "Western Governors University",
      duration: "2022 - 2025",
      descriptions: [
        "⚡ Earned a Bachelor of Science in Software Engineering with expertise in modern programming, software architecture, and engineering principles.",
        "⚡ Completed real-world projects emphasizing SDLC, Agile workflows, and DevOps practices, building scalable, user-focused applications.",
        "⚡ Developed solutions using algorithms, data structures, and object-oriented programming to tackle complex software challenges.",
        "⚡ Specialized in software testing, version control, and integration of SQL, Python, and Java for secure and scalable software systems.",
        "⚡ Recognized for outstanding academic performance by the National Society of Leadership and Success (NSLS), reflecting a high level of scholarly achievement.",
      ],
      website_link:
        "https://www.wgu.edu/online-it-degrees/software-engineering-bachelors-program.html",
    },
    {
      title: "Western Governors University",
      subtitle: "M.S. in Software Engineering – Domain Driven Design",
      logo_path: "WGULogo.png",
      alt_name: "Western Governors University",
      duration: "2024 - 2025",
      descriptions: [
        "⚡ Cloud Computing: Understand cloud systems, analyze network and cloud computing models and how they solve infrastructure problems, understand network security systems and how they can improve, and apply scalability optimization.",
        "⚡ Conceptual Model: Collaborate with domain experts and stakeholders to gather knowledge and validate models, document and ensure clarity, maintainability, and scalability.",
        "⚡ Data Structures: Identify data strcutures in order to efficiedntly meet the software needs of a business organizaiton.",
        "⚡ Microservices: Understand the deisgn principles to follow when creating a microservice, create a deployment strategy, and enhance system modularity.",
        "⚡ Software Development: Understand the SDLC, implement sofware architecture and design solutions, and understand the impact of software requirements.",
        "⚡ Software Testing: Design and implement a test strategy, create and execute test cases, and analyze and report test results.",
      ],
      website_link:
        "https://www.wgu.edu/online-it-degrees/software-engineering-masters-program/domain-driven-design.html",
    },
    {
      title: "Western Governors University",
      subtitle: "M.S. in Computer Science - AI & Machine Learning",
      logo_path: "WGULogo.png",
      alt_name: "Western Governors University",
      duration: "Current",
      descriptions: [
        "⚡ Pursuing a Master's in Computer Science with a focus on Artificial Intelligence and Machine Learning.",
        "⚡ Studying advanced algorithms, neural networks, and data science techniques to build intelligent systems.",
        "⚡ Exploring applications of AI in software development, predictive analytics, and automation.",
        "⚡ Developing expertise in machine learning frameworks and tools such as TensorFlow, PyTorch, and scikit-learn.",
        "⚡ Applying AI and machine learning concepts to real-world projects, enhancing software capabilities and user experiences.",
        "⚡ Working on projects that leverage AI and machine learning to solve complex problems and make informed decisions.",
      ],
      website_link:
        "https://www.wgu.edu/online-it-degrees/computer-science-masters-program/artificial-intelligence-machine-learning.html",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Web Fundamentals",
      subtitle: "Nucamp Coding Bootcamp",
      logo_path: "nclogo.PNG",
      certificate_link:
        "https://drive.google.com/file/d/1BsrL2UaQiw2zNin8wOrPIX6s2JYzNIAp/view?usp=drivesdk",
      alt_name: "nucamp logo",
      color_code: "#fff",
    },
    {
      title: "Bootstrap",
      subtitle: "Nucamp Coding Bootcamp",
      logo_path: "nclogo.PNG",
      certificate_link:
        "https://drive.google.com/file/d/1tWN9ICkHG2FVMzrto8EJl-BzINPXZ6PQ/view?usp=drivesdk",
      alt_name: "nucamp logo",
      color_code: "#fff",
    },
    {
      title: "React",
      subtitle: "Nucamp Coding Bootcamp",
      logo_path: "nclogo.PNG",
      certificate_link:
        "https://drive.google.com/file/d/1IxA942odCzIXmhfBNXlwYJPcZBsIZ3uB/view?usp=drivesdk",
      alt_name: "nucamp logo",
      color_code: "#fff",
    },
    {
      title: "React-Native",
      subtitle: "Nucamp Coding Bootcamp",
      logo_path: "nclogo.PNG",
      certificate_link:
        "https://drive.google.com/file/d/1uzMWP-WX4cujSfmQmuwNaBAXcgOY-jPz/view?usp=drivesdk",
      alt_name: "nucamp logo",
      color_code: "#fff",
    },
    {
      title: "Back-End Development",
      subtitle: "Nucamp Coding Bootcamp",
      logo_path: "nclogo.PNG",
      certificate_link:
        "https://drive.google.com/file/d/1qmlTTyQUOm8W85zSbT3_-4vbSjNxLIKq/view?usp=drivesdk",
      alt_name: "nucamp logo",
      color_code: "#fff",
    },
    {
      title: "Front-End & Mobile Development",
      subtitle: "Nucamp Coding Bootcamp",
      logo_path: "nclogo.PNG",
      certificate_link:
        "https://drive.google.com/file/d/1C4hFaIYp9p9xKnb5Bhgr714hqylTtOCg",
      alt_name: "nucamp logo",
      color_code: "#fff",
    },
    {
      title: "Full-Stack & Mobile Development",
      subtitle: "Nucamp Coding Bootcamp",
      logo_path: "nclogo.PNG",
      certificate_link:
        "https://drive.google.com/file/d/1L3tIjj2Aeaeif1wYX78T3UNjftB_Nlom/view?usp=drivesdk",
      alt_name: "nucamp logo",
      color_code: "#fff",
    },
    {
      title: "Coding Instructor",
      subtitle: "Nucamp Coding Bootcamp",
      logo_path: "Nucamp_Instructor.png",
      certificate_link:
        "https://learn.nucamp.co/badges/badge.php?hash=67ded2e390cf4e8b053b63a4b819cfcf028f8156",
      alt_name: "nucamp logo",
      color_code: "#fff",
    },
    {
      title: "Front-End Web Development",
      subtitle: "WGU",
      logo_path: "wgu-front-end.png",
      certificate_link:
        "https://badgr.com/public/assertions/d3R53vegQY-VWdwR_xTPLg?identity__email=dcons11@wgu.edu",
      alt_name: "WGU",
      color_code: "#fff",
    },
    {
      title: "Back-End Development",
      subtitle: "WGU",
      logo_path: "back-end-wgu.png",
      certificate_link:
        "https://badgr.com/public/assertions/2q-n-2kETd-wPPsvPrBcfA",
      alt_name: "WGU",
      color_code: "#fff",
    },
    {
      title: "Cloud Practitioner",
      subtitle: "AWS",
      logo_path: "aws-cloud.png",
      certificate_link:
        "https://www.credly.com/badges/6cf1b2d7-2a30-455a-bd68-2094da082df8/linked_in_profile",
      alt_name: "AWS",
      color_code: "#fff",
    },
    {
      title: "Web Video Accessibility",
      subtitle: "DataStax",
      logo_path: "datastax.jpeg",
      certificate_link:
        "https://badgr.com/public/assertions/CFy0NECRSMS-VE5Dx3awJQ?identity__email=daniel_constante86@hotmail.com",
      alt_name: "NSLS",
      color_code: "#fff",
    },
    {
      title: "Orientation and Leadership Training Certificate",
      subtitle: "NSLS",
      logo_path: "nsls1.png",
      certificate_link:
        "https://app.nsls.org/web/public/social/share/badge/85487sotXUJgEE7rLtTVqA",
      alt_name: "NSLS",
      color_code: "#fff",
    },
    {
      title: "Foundations of Leadership Certificate",
      subtitle: "NSLS",
      logo_path: "nsls2.png",
      certificate_link:
        "https://app.nsls.org/web/public/social/share/badge/PtygKkP74uqRES9EQ3kWNP",
      alt_name: "NSLS",
      color_code: "#fff",
    },
    {
      title: "IT Service Management Certificate",
      subtitle: "ITIL",
      logo_path: "itil-axelos.png",
      certificate_link:
        "https://drive.google.com/file/d/1vWLBl-OWOmkTGIc3Hf5NoxMqiqSqCN4I/view",
      alt_name: "ITIL",
      color_code: "#fff",
    },
    {
      title: "IT Service Management Foundation Certificate",
      subtitle: "ITIL",
      logo_path: "itil.png",
      certificate_link:
        "https://drive.google.com/file/d/11N_DCS_YbaAIU8U2zTKr50j1ESKvLyjb/view?usp=drivesdk",
      alt_name: "ITIL",
      color_code: "#fff",
    },
    {
      title: "Project Management CompTIA Project+ Certificate",
      subtitle: "CompTIA",
      logo_path: "comptia.png",
      certificate_link:
        "https://www.credly.com/badges/4e911173-c777-4780-92c0-a50ec773c8eb/linked_in_profile",
      alt_name: "CompTIA",
      color_code: "#fff",
    },
    {
      title: "Claude AI foundations Certificate",
      subtitle: "Claude",
      logo_path: "Claude_AI_symbol.svg",
      certificate_link:
        "https://drive.google.com/file/d/1zLJpxS5k8JRrRW1U7c5fvokSBex2G3mD/view?usp=drive_link",
      alt_name: "Claude",
      color_code: "#fff",
    },
    {
      title: "B.S. in Software Engineering",
      subtitle: "WGU",
      logo_path: "WGULogo.png",
      certificate_link:
        "https://drive.google.com/file/d/1YJSM7OsjHMpgkL_qillY-tNx46n8Xyua/view?usp=drivesdk",
      alt_name: "ScrumStudy",
      color_code: "#fff",
    },
    {
      title: "M.S. in Software Engineering - Domain Driven Design",
      subtitle: "WGU",
      logo_path: "WGULogo.png",
      certificate_link:
        "https://drive.google.com/file/d/1bOZf4yZ0xnKnxB7XPSiS7xp0YDKduhu2/view?usp=drive_link",
      alt_name: "ScrumStudy",
      color_code: "#fff",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Volunteer Experience",
  description:
    "As a versatile professional, I've freelanced in web development, worked with a cybersecurity startup to strengthen digital defenses, and taught coding as an instructor, empowering students with tech skills. I've contributed as a full-stack developer in the medical field and volunteered with churches and service organizations, driving impactful community projects.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Full Stack Software Engineer",
          company: "Locums.com",
          company_url: "https://www.locums.com/",
          logo_path: "locumsLogo.PNG",
          duration: "Feb 2024 - Present",
          location: "Irving, TX",
          description:
            "As a developer at Locums.com, I created a comprehensive provider dashboard allowing users to save, track, and search for locum job opportunities. I designed and implemented recruiter functionalities for posting job opportunities and facilitating seamless communication between recruiters and providers. Additionally, I developed admin panels to manage user data and optimize platform workflows.",
          color: "#000000",
        },
        {
          title: "Full Stack Software Engineer",
          company: "DC Networks",
          company_url: "https://dcnetwork.netlify.app/",
          logo_path: "dclogo.png",
          duration: "Current",
          location: "Remote",
          description:
            "At DC Networks, I provide tailored services for clients' needs, including website development, e-commerce solutions, and SEO optimization. I leverage platforms like Wix, WordPress, and Squarespace for building responsive sites, and Canva for graphic design. Additionally, I offer social media marketing to help businesses reach their target audience effectively.",
          color: "#000000",
        },
        {
          title: "Coding Instructor",
          company: "Nucamp Coding Bootcamp",
          company_url: "https://www.nucamp.co/",
          logo_path: "nucamp_logo.jfif",
          duration: "March 2022 - Dec 2024",
          location: "Dallas, TX",
          description:
            "As an instructor at Nucamp, I taught two courses: one in Web Development Fundamentals and another focused on mastering React. In the Web Development Fundamentals course, I covered HTML, JavaScript, CSS, and portfolio-building projects. In the React course, I focused on advanced React concepts, helping students build robust applications.",
          color: "#9b1578",
        },
        {
          title: "Front-End Software Engineer",
          company: "Invisinet Technologies",
          company_url: "https://www.invisinet.com/",
          logo_path: "invisinet.jfif",
          duration: "Oct 2021 - Nov 2023",
          location: "Richardson, TX",
          description:
            "At Invisinet Technologies, I developed a comprehensive platform for managing servers, identities, and API addresses. I built a certification portal for secure server and user VM access, leveraging AWS for hosting and scalability. Additionally, I created an information website to streamline system management and improve user experience.",
          color: "#0879bf",
        },
        {
          title: "Freelance Developer",
          company: "Upwork",
          company_url: "https://www.upwork.com/",
          logo_path: "upwork.png",
          duration: "Sep 2020 - May 2021",
          location: "Remote",
          description:
            "As a freelancer on Upwork, I have developed and provided services for travel apps and e-commerce platforms. I specialize in creating user-friendly, responsive websites and apps that offer seamless booking experiences and secure online shopping. My focus is on performance, scalability, and user-centric design to enhance both functionality and customer satisfaction.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Volunteer Experience",
      experiences: [
        {
          title: "Front-End Software Engineer",
          company: "Midway Church",
          company_url: "https://www.midwaychurch.org/",
          logo_path: "midway.PNG",
          duration: "May 2023 - Present",
          location: "Pilot Point, TX",
          description:
            "As a volunteer at Midway Church, I focus on improving their website's SEO optimization and performance. By enhancing site structure, keyword usage, and load times, I help ensure that the church reaches a broader audience online. My work contributes to increasing visibility and user experience.",
          color: "#4285F4",
        },
        {
          title: "Front-End Software Engineer",
          company: "Iglesia Midway",
          company_url: "https://www.midwaychurch.org/espanol",
          logo_path: "iglesia.PNG",
          duration: "May 2023 - Present",
          location: "Pilot Point, TX",
          description:
            "As a volunteer for Iglesia Midway, I developed a Spanish-language website aimed at helping the church reach a larger audience. My work focuses on creating a user-friendly experience with optimized performance to improve loading times and increase visibility, ensuring a broader online presence for the community.",
          color: "#D83B01",
        },
        {
          title: "Front-End Software Engineer",
          company: "Nucamp Coding Bootcamp",
          company_url: "https://www.nucamp.co/",
          logo_path: "nucamp_logo.jfif",
          duration: "March 2022 - Dec 2024",
          location: "Dallas, TX",
          description:
            "At Nucamp Coding Bootcamp, I developed an open-source React portfolio project structure for students. This resource allows new developers to easily build and showcase their work in a professional manner, supporting their career growth with an optimized framework for their portfolios.",
          color: "#000000",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects harness a diverse array of cutting-edge technologies, with a focus on developing Data Science solutions and deploying them as web applications using cloud infrastructure. I excel at creating innovative tools, such as those for locums.com, to drive impactful, data-driven results.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "BLOG",
  description: "Published Articles, Blogs, and Research",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "react-native-travel-app",
      name: "React-Native Travel App",
      createdAt: "2021-10-05T00:00:00Z",
      description: "Plan a perfectly tropical trip with an all-in-one app",
      url: "https://www.nucamp.co/blog/project-spotlight-daniel-constante",
    },
    {
      id: "student-spotlight",
      name: "Reel in Job-Ready Skills",
      createdAt: "2021-11-16T00:00:00Z",
      description: "Blog published at Nucamp Coding Bootcamp",
      url: "https://www.nucamp.co/blog/student-spotlight-daniel-constante",
    },
  ],
};

const articles = {
  data: [
    {
      id: "tech-career-shift-guide",
      name: "Tech Career Shift Guide",
      createdAt: "2025-01-23T00:00:00Z",
      description: "Thinking about a career change",
      path: "/tech-career-shift-guide",
    },
    {
      id: "bootcamp-vs-degree",
      name: "Bootcamp Vs Degree",
      createdAt: "2024-03-25T00:00:00Z",
      description: "My Journey in Tech and Why Education Choices Matter",
      path: "/bootcamp-vs-degree",
    },
  ],
};
const articlesContent = {
  data: [
    {
      title: "Making the Leap: Your Guide to a Tech Career Shift",
      fileName: "FullStackImg",
      description:
        "So, you're thinking about a career change. Maybe you're feeling stuck in your current role, or perhaps you're drawn to the exciting world of technology. Whatever your reason, making the leap into a tech career can be a rewarding and fulfilling experience.",
      skills: [
        "1. Identify Your Tech Interests",
        "2. Assess Your Skills and Build New Ones",
        "3. Explore Career Paths and Networking",
        "4. Prepare for Your Job Search",
        "5. Embrace Continuous Learning",
      ],
      paragrapghs: [
        "To begin, identify your specific tech interests. The tech world is vast, so pinpointing your passions is key. Do you enjoy problem-solving and building things? Consider software development, exploring roles like front-end, back-end, or full-stack developers. Are you intrigued by uncovering insights from data? Data science roles like data analyst, data scientist, and data engineer might be a good fit. Passionate about protecting systems and data? Cybersecurity offers exciting career paths such as security analyst, penetration tester, and cybersecurity engineer. Finally, if you have a knack for creating user-friendly experiences, explore the world of UX/UI design, focusing on user research and interaction (UX) or the visual design and aesthetics (UI).",
        "Next, assess your existing skills and identify those transferable across industries, such as communication, problem-solving, critical thinking, and teamwork. Then, focus on developing in-demand tech skills. Learn foundational programming languages like Python, JavaScript, and SQL. Explore data analysis tools like Excel, SQL, and Tableau. Gain experience with cloud computing platforms like AWS, Azure, or Google Cloud. Online courses on platforms like Coursera, edX, Udemy, and Codecademy can be invaluable resources. Finally, build a portfolio to showcase your projects, whether on platforms like GitHub or through a personal website.",
        "Exploring career paths and networking is crucial. Research tech companies whose cultures and values align with your interests. Attend industry events such as conferences, meetups, and hackathons to expand your network. Schedule informational interviews with professionals in your desired field to gain insights into their roles and career paths. Leverage your existing network by informing friends, family, and former colleagues about your career goals.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "devicon:typescript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Ract",
          fontAwesomeClassname: "devicon:react",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "#fff",
            color: "#fff",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "skill-icons:git",
          style: {
            color: "#2C8EBB",
          },
        },
      ],
    },
    {
      title:
        "Navigating Your Tech Career Transition: Preparation, Growth, and Education Paths",
      fileName: "CloudInfraImg",
      skills: [],
      paragrapghs: [
        "Preparing for your job search is essential. Update your resume and LinkedIn profile to highlight your relevant skills and experience. Practice your interview skills, preparing for both technical questions (coding challenges, system design) and behavioral questions. Consider seeking guidance from a career coach who can provide support, accountability, and valuable insights throughout your job search.",
        "Finally, embrace continuous learning. The tech world is constantly evolving, so cultivate a growth mindset and commit to ongoing learning. Making a career shift can be challenging, but it's incredibly rewarding. With dedication, perseverance, and the right resources, you can successfully transition into a fulfilling tech career.",
        "Choosing Your Path: University vs. Bootcamp",
        "The choice between university and bootcamp for a tech career shift depends heavily on individual circumstances and goals. University offers a broader foundation in computer science fundamentals, extensive networking opportunities, and long-term career growth potential. However, it requires a significant time and financial investment.",
        "Bootcamps, on the other hand, provide a faster-paced, practical learning experience focused on in-demand technologies and often include career support services. They are generally more affordable and shorter in duration. However, bootcamps may offer a more limited theoretical foundation and may not be suitable for all learning styles.",
      ],

      softwareSkills: [],
    },
    {
      title: "The Best Choice",
      fileName: "DesignImg",
      skills: [],
      paragrapghs: [
        "Ultimately, the best choice depends on your individual learning style, career goals, financial situation, and time constraints. Research specific programs (universities and bootcamps) that align with your interests and compare their curriculum, costs, job placement rates, and student reviews to make an informed decision.",
        "Remember, this is just a general overview. It's crucial to do your own research and carefully consider your individual needs and preferences.",
        "Disclaimer: This blog post provides general information and should not be considered professional career advice.",
        "Here are some of the Full Stack Paths:",
      ],
      stacks: [
        {
          name: "MERN",
          description:
            "MongoDB, Express.js, React, Node.js for dynamic and responsive full-stack applications.",
          logos: [
            { name: "MongoDB", className: "skill-icons:mongodb" },
            { name: "Express.js", className: "skill-icons:expressjs-dark" },
            { name: "React", className: "devicon:react" },
            { name: "Node.js", className: "logos:nodejs" },
          ],
        },
        {
          name: "RAJA",
          description:
            "React, Java, SQL, and AWS for building scalable, cloud-based enterprise solutions.",
          logos: [
            { name: "React", className: "devicon:react" },
            { name: "Java", className: "skill-icons:java-dark" },
            { name: "SQL", className: "logos:mysql" },
            { name: "AWS", className: "simple-icons:amazonaws" },
          ],
        },
        {
          name: "R2PH",
          description:
            "React, Ruby on Rails, PostgreSQL, and Heroku for developing robust, cloud-hosted applications.",
          logos: [
            { name: "React", className: "devicon:react" },
            { name: "Ruby on Rails", className: "devicon:ruby" },
            { name: "PostgreSQL", className: "logos:postgresql" },
            { name: "Heroku", className: "skill-icons:heroku" },
          ],
        },
      ],
      softwareSkills: [],
    },
  ],
};

//blog/bootcamp-vs-degree
const bootcampVsDegree = {
  data: [
    {
      title: "My Journey in Tech and Why Education Choices Matter",
      fileName: "FullStackImg",
      description:
        "Hello, my name is Daniel Constante, and I am a Full Stack Developer. Over the years, I’ve navigated the complexities of starting a tech career, filled knowledge gaps, and built a solid foundation that has shaped my professional path. My journey reflects how education—whether through bootcamps or a bachelor's degree—plays a pivotal role in preparing you for the challenges and opportunities of this industry.",
      subTitle: "Why Bootcamp Coding Was My First Choice",
      skills: [],
      paragrapghs: [
        "When I decided to transition into tech, I chose to enroll in a bootcamp. Specifically, I completed a Full Stack Development program through Nucamp. This decision was guided by two critical factors: time and cost. Unlike traditional degree programs, bootcamps offer a condensed and focused curriculum. For someone eager to dive into the field quickly without incurring substantial debt, this was an ideal starting point.",
        "Nucamp provided me with practical skills in technologies like HTML, CSS, JavaScript, and frameworks like React and Node.js. The program emphasized project-based learning, enabling me to build a portfolio that showcased my capabilities to potential employers. Additionally, the flexible schedule allowed me to balance my studies with other commitments, which is often a significant concern for adult learners or career changers.",
      ],
      subHeading: "The Reality of Gaps in Bootcamp Education",
      realityDescription:
        "While bootcamps are fantastic for jumpstarting a tech career, they are not without limitations. One of the most significant challenges I encountered after completing Nucamp was a lack of depth in key foundational areas:",
      listReality: [
        "Object-Oriented Programming (OOP): Understanding how to design and structure code effectively using OOP principles was something I had to self-learn later.",
        "Data Structures and Algorithms: These are crucial for solving complex problems and performing well in technical interviews, yet they were only briefly touched upon.",
        "Programming Foundations: Bootcamps often skip the “under-the-hood” mechanics of how programming languages and systems work, which can limit your ability to troubleshoot and optimize code.",
      ],
      endRealityParagraph:
        "These gaps became apparent as I took on more challenging projects and faced technical interviews that required a deeper understanding of computer science concepts. While bootcamps are excellent for getting your foot in the door, they often don’t provide the theoretical depth required for long-term growth in the field.",
      degreeTitle:
        "Why I Chose to Pursue a Bachelor's Degree in Software Engineering",
      degreeDescription:
        "To address these gaps, I decided to pursue a Bachelor of Science in Software Engineering from Western Governors University (WGU). WGU stood out to me for several reasons:",
      educationBenefits: [
        {
          title: "Flexible Schedule",
          description:
            "As a working professional, I needed an education program that wouldn’t disrupt my career. WGU’s competency-based model allows students to progress at their own pace. This flexibility means I can complete courses faster if I’m already familiar with the material, saving both time and money.",
          list: [],
        },
        {
          title: "Cost-Effective",
          description:
            "Higher education can be expensive, but WGU’s flat-rate tuition per term is incredibly affordable compared to traditional universities. This affordability makes it an accessible option for those who want a degree without accumulating significant student debt.",
          list: [],
        },
        {
          title: "Comprehensive Curriculum",
          description:
            "WGU’s program goes beyond the practical skills taught in bootcamps. It covers critical topics like:",
          list: [
            "Advanced Object-Oriented Programming",
            "Data Structures and Algorithms",
            "Software Architecture",
            "Operating Systems and Networking",
          ],
          subListDescription:
            "Additionally, WGU includes certifications in its curriculum, such as:",
          subList: [
            "Front-End Development",
            "Full-Stack Java Development",
            "Project Management Professional (PMP)",
            "Leadership and Management",
            "AWS Cloud Practitioner",
          ],
          endListDescription:
            "These certifications not only enhance my resume but also provide industry-recognized credentials that demonstrate expertise in specific areas.",
        },
        {
          title: "Career Advancement Opportunities",
          description:
            "While I have gained valuable experience in the field, having a bachelor's degree opens doors to roles that require formal education. Many companies value the combination of practical experience and academic credentials, especially for leadership or specialized positions.",
          list: [],
        },
      ],
      balancing: [
        {
          title: "Balancing Bootcamp Experience with a Degree",
          description:
            "Both bootcamp education and a bachelor’s degree have played significant roles in my journey. Here’s how they complement each other:",
          list: [
            "Bootcamp: Jumpstarted my career by providing hands-on skills and real-world projects.",
            "Bachelor’s Degree: Filled gaps in foundational knowledge and provided a deeper understanding of software engineering principles.",
          ],
          endListDescription:
            "If you’re just starting out in tech, a bootcamp can be an excellent way to gain entry-level skills quickly. However, be prepared to continue learning independently or through formal education to achieve long-term success.",
        },
      ],
      finalThoughtsTitle: "Final Thoughts on Education Choices",
      finalThoughtsParagrapghs: [
        "Choosing the right educational path depends on your individual goals, circumstances, and learning preferences. For me, starting with a bootcamp and then pursuing a bachelor’s degree was the perfect combination. Nucamp provided the practical skills I needed to start working in tech, while WGU is helping me build the theoretical knowledge required for advanced roles and continuous growth in the industry.",
        "If you’re considering a similar path, my advice is to evaluate your priorities. If time and cost are major concerns, a bootcamp is a great starting point. However, if you’re aiming for a comprehensive understanding of software engineering, a degree program like WGU’s can help you achieve your long-term goals.",
        "No matter which path you choose, remember that the tech industry values continuous learning. With dedication, persistence, and the right resources, you can build a rewarding career in technology.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "devicon:typescript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Ract",
          fontAwesomeClassname: "devicon:react",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "#fff",
            color: "#fff",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "skill-icons:git",
          style: {
            color: "#2C8EBB",
          },
        },
      ],
    },
  ],
};
// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "me.jpg",
    description:
      "I am available on almost every social media platform and respond within 24 hours. Whether you're seeking assistance with React, AI, Wix, SEO, or cloud-based solutions, I can help you achieve your goals. I specialize in software architecture and development, with a focus on both front-end and back-end technologies. If you need support in any of these areas, feel free to reach out—I’m here to help!",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "As a Developer Evangelist, I’m excited to share my blog with you! If you're thinking about making a career shift into tech, my blog is here to help. You'll find motivation to follow a new path, practical advice on landing a tech job, and technical knowledge to guide you through the process. Whether you're just starting or advancing in your tech journey, my blog is the place for inspiration and insights to support your success.",
    link: "https://danielconstante.netlify.app/blog",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Aubrey, TX",
    locality: "Aubrey",
    country: "USA",
    region: "Texas",
    postalCode: "76227",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://g.co/kgs/LT5MebA",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  articles,
  articlesContent,
  bootcampVsDegree,
};
